module.exports = __webpack_public_path__ + "benefit-join2.745afb6.png";